import { HTTPService } from './HttpService';
import { Tag } from '../types';

export class TagService {
  private httpService: HTTPService;

  constructor(httpService: HTTPService) {
    this.httpService = httpService;
  }

  async getTopTags(limit: number = 4): Promise<Tag[]> {
    const response = await this.httpService.get(`/tags/top?limit=${limit}`);
    return response.data;
  }

  async getAllTags(sortBy?: 'usage'): Promise<Tag[]> {
    const url = sortBy ? `/tags?usage=${sortBy === 'usage'}` : '/tags';
    const response = await this.httpService.get(url);
    return response.data;
  }

  async getTagById(id: number): Promise<Tag> {
    const response = await this.httpService.get(`/tags/${id}`);
    return response.data;
  }

  async getPhotoTags(photoId: number): Promise<Tag[]> {
    const response = await this.httpService.get(`/photos/${photoId}/tags`);
    return response.data;
  }

  async createTag(
    name: string,
    type: 'person' | 'place' | 'year' | 'event' | 'custom',
    color?: string
  ): Promise<Tag> {
    const response = await this.httpService.post('/tags', { name, type, color });
    return response.data;
  }

  async updateTag(
    id: number,
    updates: { name?: string; type?: string; color?: string }
  ): Promise<Tag> {
    const response = await this.httpService.patch(`/tags/${id}`, updates);
    return response.data;
  }

  async deleteTag(id: number): Promise<void> {
    await this.httpService.delete(`/tags/${id}`);
  }

  async addTagToPhoto(photoId: number, tagId: number): Promise<void> {
    await this.httpService.post(`/photos/${photoId}/tags`, { tagId });
  }

  async removeTagFromPhoto(photoId: number, tagId: number): Promise<void> {
    await this.httpService.delete(`/photos/${photoId}/tags/${tagId}`);
  }
}
